import Login from '../login/login';
import getUserInfo from './getUserInfo';
export default async function (forceLogin = false, rootTag, options) {
    try {
        const res = await getUserInfo({
            useServe: options?.useServe,
            useNativeRequest: options?.useNativeRequest,
        });
        if (res.result === 1 || !forceLogin) {
            return res;
        }
        else {
            if (rootTag !== undefined) {
                return Login(rootTag);
            }
            throw new Error('rootTag required');
        }
    }
    catch (err) {
        return { result: 0, error: err };
    }
}
